import type { HTMLAttributes } from 'react';
import type { LoadingProps } from '..';

export interface LoadingContainerData {
  wrapperProps?: HTMLAttributes<HTMLDivElement>;
}

export interface LoadingContainerProps extends LoadingContainerData, LoadingProps {}
